import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { Box, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AiSearchInput } from '~/components/AiSearchInput/AiSearchInput';
import { useLocaleKeys } from '~/i18n';
import { useAgreementsAiSearchStore } from './hooks/useAgreementsAiSearchStore';
import { useAgreementsAiSearchSubmit } from './hooks/useAgreementsAiSearchSubmit';
import { filterToFixedControls } from './materialize/filterToFixedControls.utils';
export const GetAgreementsAiSearchTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementsAiSearch = (param)=>{
    let { testId, onFiltersParsed } = param;
    const { AgreementsAiSearchTestIds } = useMemo(()=>GetAgreementsAiSearchTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.agreementsDashboard.aiSearch');
    const { lastQuery, filterEditedSinceLastSearch } = useAgreementsAiSearchStore(useShallow((s)=>({
            lastQuery: s.lastQuery,
            filterEditedSinceLastSearch: s.filterEditedSinceLastSearch
        })));
    const { submit, isSubmitting } = useAgreementsAiSearchSubmit((filter)=>onFiltersParsed(filterToFixedControls(filter)));
    const suggestions = useMemo(()=>[
            t.placeholders.example1(),
            t.placeholders.example2(),
            t.placeholders.example3(),
            t.placeholders.example4(),
            t.placeholders.example5(),
            t.placeholders.example6(),
            t.placeholders.example7(),
            t.placeholders.example8(),
            t.placeholders.example9()
        ], []);
    return /*#__PURE__*/ _jsx(Box, {
        testId: AgreementsAiSearchTestIds.Root(),
        width: "100%",
        children: /*#__PURE__*/ _jsx(Row, {
            width: "100%",
            children: /*#__PURE__*/ _jsx(AiSearchInput, {
                testId: AgreementsAiSearchTestIds.Input(),
                placeholder: suggestions[0],
                suggestions: suggestions,
                lastQuery: lastQuery,
                isSubmitting: isSubmitting,
                filterEditedSinceLastSearch: filterEditedSinceLastSearch,
                onSubmit: (query)=>submit(query).catch(()=>undefined),
                submitAriaLabel: t.submitSearch(),
                filtersEditedLabel: t.filtersEdited(),
                biPrefix: "agreements_ai_search"
            })
        })
    });
};
